import React, { useState, useEffect } from "react";
import "./index.less";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Input, Anchor, message, Popover, Collapse, Carousel, Dropdown, Statistic, Modal } from "antd";
import { DotLoader } from 'react-spinners';
import CountUp from 'react-countup';
import {
  RightOutlined,
  PlusOutlined
} from "@ant-design/icons";
import "animate.css";
import WOW from "wow.js";
import gonggao from "@/assets/images/gonggao1.png";
import icon1 from "@/assets/images/icon1.png";
import icon2 from "@/assets/images/icon2.png";
import icon3 from "@/assets/images/icon3.png";
import bg4 from "@/assets/images/bg4.png";

import { useAppKitAccount, useAppKit, useAppKitNetwork, useWalletInfo } from "@reown/appkit/react";
import axios from 'axios';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useSignMessage } from 'wagmi'

const { Link } = Anchor;
const Mine = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { invite } = useParams();
  const [tabIndex, setTabIndex] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSignMessage, setIsSignMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const { address, isConnected, caipAddress, status } = useAppKitAccount()
  const [infoData, setInfoData] = useState({})
  const [inviter, setInviter] = useState("")
  const [inviterAddress, setInviterAddress] = useState("")
  const { data: signature, isLoading, signMessage } = useSignMessage()
  // https://www.1322.cloud/api/login
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (signature) {
        console.log("signature", signature)
        window.sessionStorage.setItem("approveAddress", address);
        setIsSignMessage(true)
        getLogin();
      }

    }, 300);
    return () => clearTimeout(timeout);
  }, [signature]);
  useEffect(() => {
    if (address) {

      let _address = window.sessionStorage.getItem("approveAddress");
      if (_address === address) {
        getLogin()
        setIsSignMessage(true)
      } else {
        signMessageHandle()
      }

    }
  }, [address])
  const getLogin = async () => {
    try {
      const res = await axios.post('https://www.1322.cloud/api/login', {
        uid: address,
      });
      console.log("res", res.data)
      if (res.data.code === 200) {
        // setInfoData(res.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
    try {
      const res = await axios.get('https://www.1322.cloud/api/home?uid=' + address);
      console.log("res", res.data)
      if (res.data.code === 200) {
        setInfoData(res.data.data)
        setInviter(res.data.data.inviter)
        if (res.data.data.inviter === "") {
          if (invite) {
            setInviter(invite)
          }
        }
        if (res.data.data.isInvite) {
          setInviterAddress(window.location.origin + "/mine/" + address)
        }
      }
      // setResponse(res.data);
    } catch (error) {
      console.error('请求失败:', error);
    }
  }
  const signMessageHandle = async () => {
    console.log(1)
    signMessage({ message: 'DEAI Approve' })
  }
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    window.sessionStorage.setItem("lang", lang)
    setLangType(lang)
  }
  const goComingSoon = () => {
    message.warn("Coming Soon")
  }
  const goOpen = (url) => {
    window.open(url)
  }
  const onChange = ({ target: { value } }) => {
    setInviter(value)
  }
  const onCopy = () => {
    message.success(t("Copy Success"))
  }
  const tapBinding = async () => {
    if (infoData.inviter) return
    setLoading(true)
    try {
      const res = await axios.post('https://www.1322.cloud/api/bindSuperiors', {
        inviter: invite,
        uid: address,
      });
      console.log("res", res.data)
      if (res.data.code === 200) {
        // setInfoData(res.data.data)
        message.success(t("Success"))
        setLoading(false)
        getLogin()
      } else {
        setLoading(false)
        message.warn(res.data.data)
      }
      // setResponse(res.data);
    } catch (error) {
      setLoading(false)
      console.error('请求失败:', error);
    }
  }
  const goDetails = () => {
    if (!isSignMessage) {
      signMessageHandle()
    } else {
      navigate("/historyyeji")
    }
  }
  return (
    <div className="mine_box">
      <div className="tab_box">
        <div className="menu menu1" onClick={() => navigate("/stake")}>{t("Locking")}</div>
        <div className="menu active">{t("mine")}</div>
      </div>
      <div className="con_box">

        <div className="left_box">
          <div className="gonggaobox">
            <div className="title">公告</div>
            <div className="img_box">
              <div className="img_b"><img className="gonggao" src={gonggao} alt="" /></div>
              <img className="icon1" src={icon1} alt="" />
            </div>
            <div className="text" onClick={()=>setIsModalOpen(true)}>{t("gonggaotitle")}</div>
          </div>
          <div className="invite_box">
            <img className="bg" src={bg4} alt="" />
            <div className="item">
              <div className="tit">{t("My inviter")}</div>
              <div className="input_box">
                <Input className="input" value={inviter} readOnly={infoData.inviter} onChange={onChange} placeholder={t("Please enter the inviter's address")} />
                <Button type="primary" loading={loading} className="btn" onClick={tapBinding}>{infoData.inviter ? t("Binded") : t("Binding")}</Button>
              </div>
              <div className="tit1">{t("My invitation link")}</div>
              <div className="input_box">
                <Input className="input" value={inviterAddress} readOnly placeholder={t("No invitation qualification")} />
                {
                  inviterAddress ? <CopyToClipboard text={inviterAddress}
                    onCopy={onCopy}>
                    <Button type="primary" className="btn">{t("copy")}</Button>
                  </CopyToClipboard> : null
                }
              </div>

            </div>
          </div>
        </div>
        <div className="right_box">
          <div className="top">
            <img className="icon" src={icon2} alt="" />
            <div className="tit">
              <div >{t("My achievements")}</div>
              <div className="deatils" onClick={goDetails}>{t("Details")}</div>
            </div>
            <div className="box">
              <div className="item_box">
                <div className="num">{infoData.total_deai || 0}</div>
                <div className="text">{t("deai total performance")}</div>
              </div>
              <div className="item_box">
                <div className="num">{infoData.total_lp || 0}</div>
                <div className="text">{t("LP performance")}</div>
              </div>
              <div className="item_box">
                <div className="num">{infoData.total_new_deai || 0}</div>
                <div className="text">{t("Total new performance")}</div>
              </div>
            </div>
          </div>
          <div className="data_box">
            <div className="tit">{t("Data Overview")}</div>
            <div className="item_box">
                          <img className="icon" src={icon3} alt="" />

              <div className="item">
                <div className="item_con">
                  <div className="num">{infoData.groupNum || 0}</div>
                  <div className="text">{t("Number of teams")}</div>
                </div>
                <div className="item_con">
                  <div className="num">{infoData.lockNum || 0}</div>
                  <div className="text">{t("Team lock-up")}</div>
                </div>
              </div>
              <div className="item">
                <div className="item_con">
                  <div className="num">{infoData.cq_lock_integral || 0}</div>
                  <div className="text">{t("CQ locked quantity")}</div>
                </div>
                <div className="item_con">
                  <div className="num">{infoData.cq_invite_integral || 0}</div>
                  <div className="text">{t("CQ Invitation Benefits")}</div>
                </div>
              </div>
              <div className="item">
                <div className="item_con">
                  <div className="num">{infoData.zy_lock_integral || 0}</div>
                  <div className="text">{t("ZY lock-up income")}</div>
                </div>
                <div className="item_con">
                  <div className="num">{infoData.zy_invite_integral || 0}</div>
                  <div className="text">{t("ZY invitation income")}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
       <Modal title={""} centered open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
              <div className="gonggaomsg">
                <div className="tit">{t("gonggaotitle")}</div>
                <div className="msg">{t("gonggaotext1")}</div>
                <div className="msg">{t("gonggaotext2")}</div>
                <div className="msg">{t("gonggaotext3")}</div>
                <div className="msg">{t("gonggaotext4")}</div>
                <div className="msg">{t("gonggaotext5")}</div>
                <div className="msg">{t("gonggaotext6")}</div>
                <div className="msg">{t("gonggaotext7")}</div>
                <div className="msg">{t("gonggaotext8")}</div>
                <div className="msg">{t("gonggaotext9")}</div>
                <div className="msg">{t("gonggaotext10")}</div>
                <div className="msg">{t("gonggaotext11")}</div>
                <div className="msg">{t("gonggaotext12")}</div>
              </div>
            </Modal>
    </div >
  );
};
export default Mine;
